// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectSite model hasMany relations 1`] = `
Array [
  "Contact",
]
`;
